module.exports = __webpack_public_path__ + "img/cleaning-service.757a9b19.jpg";